import {ILocalisation} from '../../../@interfaces/services/Localisation/ILocalisation';
import {IMessagesBag} from '../../../@interfaces/services/Localisation/IMessagesBag';

export enum LocalisationEvents {
	SET_MESSAGES = 'localisation@set-messages',
	SET_LOCALE = 'localisation@set-locale',
	SET_FALLBACK_LOCALE = 'localisation@set-fallback-locale',
}

export type LocalisationEventPayload = {
	service: ILocalisation,
	messages?: IMessagesBag,
	oldLocale?: string,
	newLocale?: string,
}
